// extracted by mini-css-extract-plugin
export default {"booking_type_badge":"MeetingRoomsSearch_booking_type_badge__Gogrf"};